var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{attrs:{"data":_vm.menuItems,"node-key":"id","default-expand-all":""},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }